<template>
  <v-container>
    <v-row wrap>
      <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="mb-0 pb-0">
        <v-card flat>
          <v-card-text class="pa-0  pt-6">
            <v-row class="grey lighten-4 mx-0 py-6 px-6">
              <v-col cols="12" sm="2" class="d-none d-sm-flex text-center">
                <v-avatar :size="150" color="purple lighten-4">
                  <v-img
                    fluid
                    :src="
                      current_user && current_user.foto
                        ? current_user.foto
                        : current_user && current_user.kelamin == 'P'
                        ? 'https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/img-default-perempuan.png'
                        : 'https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/img-default-laki.png'
                    "
                  >
                  </v-img>
                </v-avatar>
              </v-col>
              <v-col cols="12" sm="8" md="8" lg="8" xl="8" class="ml-3">
                <p class="headline black--text font-weight-bold mb-0 pb-0 pt-0 mt-n1">{{ pVal(current_user, "name") }}</p>
                <p class="py-0 my-0 caption">{{ pVal(current_user, "email") }}</p>
                <p v-if="!current_user.is_super_admin && false" class="pt-4">
                  <v-alert v-if="!current_user.komunitas_id" icon="mdi-alert" cols="12" dense text type="warning" class="caption">
                    Belum bergabung dengan komunitas tertentu &nbsp;
                    <m-button outlined x-small color="orange" class="white--text ma-0 float-sm-right" textButton="Bergabung" action="pilih" @pilih="toSIMPKB()"></m-button>
                  </v-alert>
                  <span class="caption green--text" v-else>{{ pVal(current_user, "komunitas") }}</span>
                </p>
                <p class="my-4 pt-0" v-if="current_user.peran_dapodik">
                  <v-chip label color="purple lighten-5 purple--text"
                    >{{ current_user.peran_dapodik.keterangan | toTitleCase }}
                    {{ current_user.jenjang ? current_user.jenjang.keterangan : "" }}</v-chip
                  >
                </p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-row wrap>
          <v-col cols="12"><m-breadcrum :items="bread"></m-breadcrum></v-col>
          <v-col cols="12" class="text-h4 font-weight-bold mb-0 pb-0">Daftar Seri</v-col>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6" v-for="item in items" :key="item.id">
            <BlockCard
              :isReady="item.is_tutup ? false : item.is_rilis ? true : false"
              :title="item.nama"
              :item="item"
              :newSeries="item.is_new"
              :logo="item.cover"
              style="height:100%"
              color="primary"
              @reload="load"
              @edit="edit(item)"
              @pilih="pilihInstansi(item)"
              to
            />
          </v-col>
          <Form ref="dlg" />
        </v-row>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { SIMPKB } from "@/const";
import Form from "../../user/components/Form.vue";

function compare(a, b) {
  if (a.id < b.id) {
    return 1;
  }
  if (a.id > b.id) {
    return -1;
  }
  return 0;
}

export default {
  components: {
    BlockCard: () => import("@/components/BlockCard"),
    Form
  },
  data() {
    return {
      instansi: {},
      textSearch: "",
      items: [],
      current_page: 1,
      hsidebar: false,
      page: null,
      cp: 1,
      dialog: true,
      jenjangs: []
    };
  },
  activated() {
    this.dialog = true;
    this.$store.commit("main/setLDrawer", false);
  },
  mounted() {
    this.$store.commit("main/setLDrawer", false);
    this.current_page = 1;
    this.load();
  },
  methods: {
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    updateJenjang() {
      this.$refs.dlg.open(this.current_user).then(() => {
        this.load();
      });
    },
    toKelola() {
      this.$router.push({
        name: "instansi.pilih.admin"
      });
    },
    toSIMPKB() {
      window.open(SIMPKB, "_blank");
    },
    pencarian() {
      this.cp = 1;
      this.current_page = 1;
      this.load();
    },
    load() {
      return this.$store
        .dispatch("instansi/get", {
          page: this.current_page,
          s: this.textSearch,
          parent_id: this.$route.params.parent_id
        })
        .then(res => {
          this.page = res;
          this.items = res.sort(compare).filter(ins=>ins.is_gbb==0);
        })
        .catch(e => e);
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    // eslint-disable-next-line
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store.dispatch("instansi/create", this.instansi);
        })
        .then(res => {
          this.instansi.nama = "";
          this.pilihInstansi(res.data);
          this.$refs.dlg.resolve();
          return res;
        })
        .catch(e => e);
    },
    change() {
      this.load();
    },
    pilihInstansi(item) {
      return this.$store
        .dispatch("instansi/switchInstansi", item.id)
        .then(() => {
          if (item.kode == "p3k") {
            return this.$router.push({
              name: "beranda.pppk",
              params: { instansi_id: item.id }
            });
          } else {
            return this.$router.push({
              name: "beranda",
              params: { instansi_id: item.id }
            });
          }
        })
        .catch(e => e);
    }
  },
  watch: {
    hsidebar(n) {
      this.$store.commit("main/setHsidebar", n);
    }
  },
  computed: {
    is_disabled() {
      return this.CONFIG.SINGKRONISASI == "true" ? true : false;
    },
    bread() {
      return [
        {
          icon: "mdi-home",
          title: "Pilihan Diklat",
          to: { name: "instansi.pilih" }
        },
        {
          icon: "mdi-edit",
          title: "Sub Seri"
        }
      ];
    }
  }
};
</script>

<style></style>
